import { render, staticRenderFns } from "./doanswer.vue?vue&type=template&id=1745febf&scoped=true&"
import script from "./doanswer.vue?vue&type=script&lang=js&"
export * from "./doanswer.vue?vue&type=script&lang=js&"
import style0 from "./doanswer.vue?vue&type=style&index=0&id=1745febf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745febf",
  null
  
)

export default component.exports